// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__iqkgd","box":"WorkspacesBox_box__1H59d","node":"WorkspacesBox_node__2qA2G"};